export default function ManualPlateButton({ onClick }) {
  return <button type="button" className="plate-camera__manual" onClick={onClick}>ورود دستی پلاک</button>;
}
